import React, { useRef, useState } from "react";
import { Play, Pause, Check } from "lucide-react";

const MUSIC_LIBRARY = [

{
id:"corporate",
title:"Corporate Elegance",
category:"Elegante",
preview:"/audio/music/preview/alex-morgan-corporate-business-background-music-571649-preview.mp3",
file:"/audio/music/alex-morgan-corporate-business-background-music-571649.mp3"
},

{
id:"jazz-coffee",
title:"Jazz Coffee Shop",
category:"Elegante",
preview:"/audio/music/preview/alex-morgan-jazz-coffee-shop-music-571652-preview.mp3",
file:"/audio/music/alex-morgan-jazz-coffee-shop-music-571652.mp3"
},

{
id:"rainy-night",
title:"Jazz Rainy Night",
category:"Romantica",
preview:"/audio/music/preview/alex-morgan-jazz-rainy-night-music-571656-preview.mp3",
file:"/audio/music/alex-morgan-jazz-rainy-night-music-571656.mp3"
},

{
id:"travel",
title:"Travel Adventure",
category:"Viaggio",
preview:"/audio/music/preview/bombinsound-advertising-traveling-571352-preview.mp3",
file:"/audio/music/bombinsound-advertising-traveling-571352.mp3"
},

{
id:"trap1",
title:"Party Beat 1",
category:"Party",
preview:"/audio/music/preview/bombinsound-trap-trap-beat-beats-version-1-warriors-571370-preview.mp3",
file:"/audio/music/bombinsound-trap-trap-beat-beats-version-1-warriors-571370.mp3"
},

{
id:"trap2",
title:"Party Beat 2",
category:"Party",
preview:"/audio/music/preview/bombinsound-trap-trap-beat-beats-version-2-warriors-571367-preview.mp3",
file:"/audio/music/bombinsound-trap-trap-beat-beats-version-2-warriors-571367.mp3"
},

{
id:"pop1",
title:"Future Pop",
category:"Party",
preview:"/audio/music/preview/jonasblakewood-future-pop-upbeat-569721-preview.mp3",
file:"/audio/music/jonasblakewood-future-pop-upbeat-569721.mp3"
},

{
id:"pop2",
title:"Pop Dance",
category:"Party",
preview:"/audio/music/preview/jonasblakewood-pop-dance-569720-preview.mp3",
file:"/audio/music/jonasblakewood-pop-dance-569720.mp3"
},

{
id:"summer",
title:"Summer Vibes",
category:"Party",
preview:"/audio/music/preview/jonasblakewood-summer-569733-preview.mp3",
file:"/audio/music/jonasblakewood-summer-569733.mp3"
},

{
id:"motivation",
title:"Motivation",
category:"Evento",
preview:"/audio/music/preview/verclub_music-motivation-571038-preview.mp3",
file:"/audio/music/verclub_music-motivation-571038.mp3"
},

{
id:"relax",
title:"Relax",
category:"Romantica",
preview:"/audio/music/preview/verclub_music-relaxing-music-571029-preview.mp3",
file:"/audio/music/verclub_music-relaxing-music-571029.mp3"
},

{
id:"sleep",
title:"Dream Night",
category:"Romantica",
preview:"/audio/music/preview/verclub_music-sleep-music-571041-preview.mp3",
file:"/audio/music/verclub_music-sleep-music-571041.mp3"
}

];


export default function MusicPicker({value,onChange}){

const audioRef=useRef(null);
const [playing,setPlaying]=useState(null);


function previewMusic(track){

if(!audioRef.current)return;


if(playing===track.id){

audioRef.current.pause();
setPlaying(null);
return;

}


audioRef.current.src=track.preview;
audioRef.current.currentTime=0;
audioRef.current.volume=0.7;

audioRef.current.play();

setPlaying(track.id);


setTimeout(()=>{

audioRef.current.pause();
setPlaying(null);

},6000);


}



return(

<div className="space-y-5">

<h3 className="text-xl font-serif">
Seleziona la tua musica di sottofondo
</h3>


<p className="text-sm opacity-70">
Ascolta una breve anteprima e scegli la musica perfetta per il tuo invito.
</p>


<audio ref={audioRef}/>


<div className="grid gap-3">

{
MUSIC_LIBRARY.map(track=>(

<div
key={track.id}
className="flex items-center justify-between border rounded-xl p-4 bg-white/60"
>


<div>

<div className="font-medium">
{track.title}
</div>

<div className="text-xs opacity-60">
{track.category}
</div>

</div>


<div className="flex gap-2">


<button
type="button"
onClick={()=>previewMusic(track)}
className="rounded-full border p-2"
>

{
playing===track.id
?
<Pause size={18}/>
:
<Play size={18}/>
}

</button>


<button
type="button"
onClick={()=>onChange(track)}
className="rounded-full border p-2"
>

{
value?.id===track.id
?
<Check size={18}/>
:
"+"
}

</button>


</div>


</div>

))
}

</div>

</div>

)

}
